module.exports = __webpack_public_path__ + "img/27_25.96f4533e.png";